import { render, staticRenderFns } from "./AddShipmentOtherModal.vue?vue&type=template&id=7f20f53e&"
import script from "./AddShipmentOtherModal.vue?vue&type=script&lang=js&"
export * from "./AddShipmentOtherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports